import createVueComponent from '../createVueComponent';

const MoreHorizontal = createVueComponent('MoreHorizontalIcon', [
  ['circle', { cx: '12', cy: '12', r: '1', key: '41hilf' }],
  ['circle', { cx: '19', cy: '12', r: '1', key: '1wjl8i' }],
  ['circle', { cx: '5', cy: '12', r: '1', key: '1pcz8c' }],
]);

export default MoreHorizontal;
